module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/OM-34965b1071a49546ed553292da99adf2.png";